export const FLOW_SUGGESTION_TABLE = "flowSuggestions"
export const FLOW_SUGGESTION_TABLE_SCHEMA = "id, companyId, targetId, syncId"
